import React, { useEffect, useState } from 'react';
import {Image} from '@shopify/hydrogen';
import 'rc-slider/assets/index.css';
import arrowSearch from '../../../assets/image/arrow-search.svg';
import { useAppSelector } from '../../../lib/hooks';
import { calculateNewOptions } from '../common/utils';
import TagList from './common/TagList.client';

export default function Brand({}) {  
  return (
    <>
      <TagList title={"Marca"} apiSection={"brand"}></TagList>
    </>
  );
}
